import React from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";

export const EpisodeCard = ({ episode }) => (
    <Link
        to={`/episodes/${episode.id}`}
        data-testid={`episode-card-${episode.id}`}
        className="episode-card group block"
    >
        <div className="aspect-[4/3] overflow-hidden bg-black/5 mb-5 relative">
            {episode.cover_image ? (
                <img
                    src={episode.cover_image}
                    alt={episode.title}
                    className="w-full h-full object-cover episode-cover"
                />
            ) : (
                <div className="w-full h-full bg-gradient-to-br from-black to-[#1a1a1a]" />
            )}
            <div className="absolute bottom-4 left-4 w-12 h-12 rounded-full bg-[#D4AF37] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <Play size={16} fill="black" />
            </div>
        </div>
        <div className="flex items-center gap-3 mb-3">
            {episode.episode_number != null && (
                <span className="eyebrow text-[#B8860B]">Ep. {String(episode.episode_number).padStart(2, "0")}</span>
            )}
            {episode.duration && <span className="text-xs text-black/50">· {episode.duration}</span>}
        </div>
        <h3 className="font-serif text-2xl md:text-[26px] leading-snug tracking-tight group-hover:text-[#B8860B] transition-colors">
            {episode.title}
        </h3>
        <p className="text-sm text-black/60 mt-3 line-clamp-2 font-light leading-relaxed">{episode.description}</p>
    </Link>
);
